import React from "react";
import { useRecoilValue } from "recoil";
import { RootStackNavigator } from ".";
import { userStateAtom } from "../user/userAtoms";
import { BottomTabStack } from "./BottomTabStack";
import { HeaderRight } from "./HeaderRight";
import { NotLoggedInScreen } from "./NotLoggedInScreen";

export const RootStack = () => {
    const userState = useRecoilValue(userStateAtom);
    return (
        <RootStackNavigator.Navigator
            screenOptions={{
                title: "Juicy",
                headerTransparent: true,
                headerRight: () => <HeaderRight />,
            }}
        >
            {!userState ? (
                <RootStackNavigator.Screen name="NotLoggedInScreen" component={NotLoggedInScreen} />
            ) : (
                <RootStackNavigator.Screen name="BottomTabStackScreen" component={BottomTabStack} />
            )}
        </RootStackNavigator.Navigator>
    );
};
